import { USER_TYPE, WPC_ROLE_PRIVILEGE_ORDER } from './constants'

/** Rank a WPC role. Higher is more privileged; anything unrecognized ranks lowest. */
const wpcPrivilegeRank = (role) => {
  const index = WPC_ROLE_PRIVILEGE_ORDER.indexOf(role)

  if (index === -1) return -1

  return WPC_ROLE_PRIVILEGE_ORDER.length - 1 - index
}

/**
 * WARP-939 — may `actor` view as `target`?
 *
 * Mirrors `core.rules.can_user_impersonate_target` so the button is hidden rather than
 * offered and then refused. The server is what enforces this; this copy only keeps the
 * UI honest.
 *
 * The rule is no privilege escalation: you may view as anyone at or below your own WPC
 * role. Dealer users are never a privilege gain, so they stay open.
 */
export const canViewAsUser = (actor, target) => {
  if (!actor || !target) return false
  if (target.userType !== USER_TYPE.WPC) return true

  return (
    wpcPrivilegeRank(actor.ssoUserProfile?.role) >= wpcPrivilegeRank(target.ssoUserProfile?.role)
  )
}

export default canViewAsUser
